
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeUnknownFilled as ObiVesselTypeUnknownFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-unknown-filled.js';
 
 
 

 
 export const ObiVesselTypeUnknownFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-unknown-filled',
   elementClass: ObiVesselTypeUnknownFilledElement,
   events: {
     
   }
  });
 
 